// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6edebf7b","328":"22c13835","536":"b942f648","543":"a7a50f65","968":"8c1c0d61"}[chunkId] + ".chunk.js";
};